
/*========================================
        Imports!!!
=========================================*/

/*--css--*/
import '../assets/css/staticElements.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

/*--cows footer--*/

import mu1 from '../assets/footer/img10.webp';
import mu2 from '../assets/footer/img3.webp';
import mu3 from '../assets/footer/img1.webp';
import mu4 from '../assets/footer/img17.webp';
import mu5 from '../assets/footer/img18.webp';
import mu6 from '../assets/footer/img12.webp';
import social2 from '../assets/icons/phone.webp';
import social3 from '../assets/icons/mail.webp';
import social1 from '../assets/icons/factory.webp';

/*--logo--*/
import logo from '../assets/img/logo.webp';
  

/*========------------========*/
/*========------------========*/
/*------Footer------*/
/*========------------========*/
/*========------------========*/

function Footer() {
    return (
      <>
        <section className='footer'>
          <Row className='MiniGallery'>
            {/*-short gallery-*/}
            <Col lg={6} md={12} xs={12} className='mincol'>
              <section className='stadko'>
                {/*-logo-*/}
                <div className='FooterLogo'>
                  <a href='#Contact' rel="noreferrer">
                    <Row>
                      <Col lg={2} md={1} xs={2} className='logoFooter'>
                        <p>
                          <img src={logo} alt='logo' />
                        </p>
                      </Col>
                      <Col lg={10} md={11} xs={10} className='logoFooter'>
                        <h2>Fortiq</h2>
                      </Col>
                    </Row>
                  </a>
                </div>
                {/*-photos-*/}
                <div className='smallGallery'>
                  <Row>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu6} alt="Equipment"/>
                      </a>  
                    </Col>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu4} alt="Equipment"/>
                      </a>
                    </Col>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu3} alt="Equipment"/>
                      </a>
                    </Col>
                  </Row>
                  <Row className='tooff'>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu2} alt="Equipment"/>
                      </a>
                    </Col>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu5} alt="Equipment"/>
                      </a>
                    </Col>
                    <Col lg={4} md={4} xs={12} className='cowCol'>
                      <a href='#Contact' rel="noreferrer">
                        <img src={mu1} alt="Equipment"/>
                      </a>
                    </Col>
                  </Row>
                </div>
              </section>
            </Col>
            {/*-Contact-*/}
            <Col lg={6} md={12} xs={12}  className='mincol'>
                <section className='contact' id='Contact'>
                  {/* <div>
                    <h2>Kontakt</h2>
                  </div> */}
                  <section className='links'>
                    {/*-phone-*/}
                    <Row className='package'>
                      <Col lg={2} md={3} xs={12} className='Colek'>
                        <a href='tel:+48 696 009 727'>
                          <img src={social2} alt="socialek" loading="lazy" />
                        </a>
                      </Col>
                      <Col lg={9} md={9} xs={12} className='Colek'>
                        <span>+48 696 009 727</span>
                      </Col>
                    </Row>
                    {/*-instagram-*/}
                    <Row className='package'>
                      <Col lg={2} md={3} xs={12} className='Colek'>
                        <a href='mailto:biuro@fortiq.pl' rel="noreferrer">
                          <img src={social3} alt="socialek" loading="lazy" />
                        </a>
                      </Col>
                      <Col lg={9} md={9} xs={12} className='Colek'>
                        <a href='mailto:biuro@fortiq.pl' rel="noreferrer">
                          <span>biuro@fortiq.pl</span>
                        </a>
                      </Col>
                    </Row>
                    <Row className='package'>
                      <Col lg={2} md={3} xs={12} className='Colek'>
                        <a href='#Contact' rel="noreferrer">
                          <img src={social1} alt="socialek" loading="lazy" />
                        </a>
                      </Col>
                      <Col lg={9} md={9} xs={12} className='Colek'>
                      <a href='#Contact' rel="noreferrer">
                          <div className='FactoryData'>
                            <p>FORTIQ sp.z o. o</p>
                            <p>Biuro: ul. W.Doroszewskiego 7</p>
                            <p>01-318 Warszawa</p>
                            <p>NIP: 5223331819</p>
                          </div>
                        </a>
                      </Col>
                    </Row>
                  </section>
              </section>
            </Col>
          </Row>
          {/*-Copyright-*/}
          <Row>
            <Col lg={12} md={12} xs={12} className='copyright'>
              <div className='copya'>All rights reserved. Created by <a href="https://pixelpick.pl"> PixelPick</a></div>
            </Col>
          </Row>
        </section>
      </>
    );
}
  
export default Footer;